export const productList=[
    'school','home-international','naurasha_home','demo_school','school_japan','vna_labs','cards_app','cards_app_school','logopedia','robot_key','japan_reg','gibridNaurashaVNR','Germain-school','demoSchoolAndroidFrance','school-demo',
    'b2b demo','france_offline','school_kazakh', 'expedition_magnet', 'japan_home', 'cl_school', 'home_edition', 'sensor-tool'
];

const STORED_PRODUCTS = "analytics stored products";
const SERVER_AUTH_URL_PROPS = 'server authUrl';
const SERVER_STAT_URL_PROPS = 'server statServerUrl';
const SERVER_PORT_PROPS = 'server port';

export function saveProducts(products) {
  localStorage.setItem(STORED_PRODUCTS,JSON.stringify(products));
}

export function getStoredProducts() {
  const stored = localStorage.getItem(STORED_PRODUCTS);
  return stored ? JSON.parse(stored) :productList;
}

export function saveAuthUrl(authUrl) {
    localStorage.setItem(SERVER_AUTH_URL_PROPS, authUrl);
}

export function saveStatServerUrl(statServerUrl) {
    localStorage.setItem(SERVER_STAT_URL_PROPS, statServerUrl);
}

export function savePort(port) {
    localStorage.setItem(SERVER_PORT_PROPS,port);
}

export function getStoredAuthUrl() {
    return  localStorage.getItem(SERVER_AUTH_URL_PROPS);
}

export function getStoredStatServerUrl() {
    return  localStorage.getItem(SERVER_STAT_URL_PROPS);
}

export function getStoredPort() {
    return  localStorage.getItem(SERVER_PORT_PROPS);
}